import { useContext, useEffect, useState } from "react"
import { RiCloseFill } from "react-icons/ri"
import { AppSpan, Button, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, ReactSelect, SidePopupContainer } from "src/style"
import { ReactComponent as EmailIcon } from 'src/assets/img/email-icon.svg'
import { ReactComponent as InstitutionIcon } from 'src/assets/img/institution-icon.svg'
import { ReactComponent as InstitutionFillIcon } from 'src/assets/img/institution-fill-icon.svg'
import { components } from "react-select";
import utility from "src/utils/utility"
import { useNotifier } from "react-pop-notifier"
import ApiContext from "src/provider/API/call-service"
import { Institution, SharePayload } from "src/model"

export const ProductSharing: React.FC<any> = ({ productId, close }) => {
    const { notifier } = useNotifier()
    const { API } = useContext(ApiContext)
    const [shareTo, setShareTo] = useState('')
    const [input, setInput] = useState<any>({ recipientEmail: '', comment: '', institution: null })
    const [institutions, setInstitutions] = useState<Array<Institution> | null>(null)

    const { Option } = components;
    const IconOption = (props: any) => (
        <Option {...props}>
            <InstitutionFillIcon style={{ marginRight: '1.5rem' }} />
            {props.data.label}
        </Option>
    );

    useEffect(() => {
        handleFetchInstitutionsForSharing()
    }, [])

    async function handleFetchInstitutionsForSharing() {
        const response = await API.getAllInstitutions()
        if (response) setInstitutions(response)
    }

    
    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault();
    
        const payload: SharePayload = {
            ...input,
            productId: productId,
            emails: [input.recipientEmail]
        };
        let response = null;
    
        if (shareTo === 'email') {
            response = await API.shareToEmail(payload);
        } 
        else {
            response = await API.shareToInstitution(productId, input.institution.value);
        } 
       
        if (response) close();

    }
    
    
    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start"
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">Share product</AppSpan>
                    <Button
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{ fontSize: '2.3rem' }} />
                    </Button>
                </FlexRow>
                {!shareTo ?
                    <CustomContainer topMargin="2">
                        <FlexRow
                            gap="1" minHeight="6" borderColor="#EAECF0"
                            radius="0.8" padding="1.6"
                            onClick={() => setShareTo('email')}
                        >
                            <EmailIcon className="icon-component" />
                            <AppSpan
                                textSize="1.6" color="#0A756F"
                                fontWeight="500" cursor="pointer"
                            >
                                Share to email
                            </AppSpan>
                        </FlexRow>
                        <FlexRow
                            gap="1" minHeight="6" borderColor="#EAECF0"
                            radius="0.8" padding="1.6" topMargin="1"
                            onClick={() => setShareTo('institution')}
                        >
                            <InstitutionIcon className="icon-component" />
                            <AppSpan
                                textSize="1.6" color="#0A756F"
                                fontWeight="500" cursor="pointer"
                            >
                                Share to institution
                            </AppSpan>
                        </FlexRow>
                    </CustomContainer>
                    :
                    <CustomContainer topMargin='1.5'>
                        {shareTo === 'email' ?
                            <FlexRow
                                gap="1"
                                onClick={() => setShareTo('email')}
                            >
                                <EmailIcon className="icon-component" />
                                <AppSpan
                                    textSize="1.6" color="#0A756F"
                                    fontWeight="500" cursor="pointer"
                                >
                                    Share to email
                                </AppSpan>
                            </FlexRow>
                            :
                            <FlexRow
                                gap="1"
                                onClick={() => setShareTo('institution')}
                            >
                                <InstitutionIcon className="icon-component" />
                                <AppSpan
                                    textSize="1.6" color="#0A756F"
                                    fontWeight="500" cursor="pointer"
                                >
                                    Share to institution
                                </AppSpan>
                            </FlexRow>
                        }
                        <Form onSubmit={handleSubmit} topMargin='1.5'>
                            {shareTo === 'email' &&
                                <FormGroup>
                                    <input
                                        placeholder="Recipient email address"
                                        name='recipientEmail'
                                        value={input.recipientEmail}
                                        onChange={(e) => setInput({ ...input, recipientEmail: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            }
                            {shareTo === 'institution' &&
                                <ReactSelect
                                    bottomMargin="2"
                                    styles={utility.reactSelectStyles()}
                                    options={
                                        institutions?.map((item: any, index: number) => {
                                            return {
                                                label: item.name,
                                                value: item.code,
                                                key: index
                                            }
                                        })
                                    }
                                    isClearable={true}
                                    isSearchable={true}
                                    name='institution'
                                    placeholder="Select Institution"
                                    menuPortalTarget={document.body}
                                    value={input.institution}
                                    onChange={(val) => setInput({ ...input, institution: val })}
                                    components={{ Option: IconOption }}
                                />
                            }
                            <FormGroup>
                                <label>Comment</label>
                                <textarea
                                    placeholder="What's on your mind"
                                    name='comment'
                                    value={input.comment}
                                    onChange={(e) => setInput({ ...input, comment: e.target.value })}
                                    required
                                />
                            </FormGroup>

                            <FlexRow justifyContent='flex-end'>
                                <Button
                                    width='8.1'
                                    titleSize='1.4' fontWeight="500"
                                    height='4' radius='0.8'
                                    bottomMargin='1' hoverColor='#0D968F'
                                    hoverBgColor='#fff' borderColor='#0D968F'
                                >
                                    Submit
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                }
            </FlexColumn>
        </>
    )
}